import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch} from '@fortawesome/free-solid-svg-icons'

import './AddChild.css';

class AddChild extends React.Component{
constructor(props){
  super(props);
  this.state = {
    data:[],
    childNo:'',
    childName:'',
    childSurname:'',
    allergies:[],
    allergy:'',
    childClass:'',
    childGender:'',
    collector1No:'',
    collector1Rel:'',
    col1mon:false,
    col1tue:false,
    col1wed:false,
    col1thu:false,
    col1fri:false,
    collector2No:'',
    collector2Rel:'',
    col2mon:false,
    col2tue:false,
    col2wed:false,
    col2thu:false,
    col2fri:false,
    collector3No:'',
    collector3Rel:'',
    col3mon:false,
    col3tue:false,
    col3wed:false,
    col3thu:false,
    col3fri:false,
    collector4No:'',
    collector4Rel:'',
    col4mon:false,
    col4tue:false,
    col4wed:false,
    col4thu:false,
    col4fri:false,
    searchShow:'searchHide',
    colSearch:[],
    searchName:'',
    searchSurname:'',
    colNo1:'',
    colNo2:'',
    colNo3:'',
    colNo4:'',
    colNo1phone:'',
    colNo2phone:'',
    colNo3phone:'',
    colNo4phone:'',
    Colnumber:0,
    childCat:'',
    childSchoolID:'',
  }
}
componentDidMount(){
fetch('https://schoolportal.appsdesign.co.za/get_class/' + localStorage.getItem('schoolToken'))
.then((response) => response.json())
.then((responseJson) => {
console.log(responseJson[0])
  this.setState({
    data: responseJson,

}, function(){

  });
console.log(this.state.data)
})
.catch((error) =>{
  console.error(error);
});




fetch('https://schoolportal.appsdesign.co.za/school_collector/' + localStorage.getItem('schoolToken'))
.then((response) => response.json())
.then((responseJson) => {
console.log(responseJson[0])
  this.setState({
    colSearch: responseJson,

}, function(){

  });
console.log(this.state.colSearch)
})
.catch((error) =>{
  console.error(error);
});





}

onSearchName = (e) =>{

  this.setState({searchName:e.target.value}, function(){
    console.log('name changed')
  })
}



onSearchSurname = (e) =>{

  this.setState({searchSurname:e.target.value}, function(){
    console.log('name changed')
  })
}





  setCol1mon = () =>{
     this.setState(
       { col1mon: !this.state.col1mon },
       function(){
       console.log(this.state.col1mon);
     });

}


  setCol1tue = () =>{
     this.setState(
       { col1tue: !this.state.col1tue },
       function(){
       console.log(this.state.col1tue);
     });

}
setCol1wed = () =>{
   this.setState(
     { col1wed: !this.state.col1wed },
     function(){
     console.log(this.state.col1wed);
   });

}


setCol1thu = () =>{
   this.setState(
     { col1thu: !this.state.col1thu },
     function(){
     console.log(this.state.col1thu);
   });

}



setCol1fri = () =>{
   this.setState(
     { col1fri: !this.state.col1fri },
     function(){
     console.log(this.state.col1fri);
   });

}




  setCol2mon = () =>{
     this.setState(
       { col2mon: !this.state.col2mon },
       function(){
       console.log(this.state.col2mon);
     });

}


  setCol2tue = () =>{
     this.setState(
       { col2tue: !this.state.col2tue },
       function(){
       console.log(this.state.col2tue);
     });

}
setCol2wed = () =>{
   this.setState(
     { col2wed: !this.state.col2wed },
     function(){
     console.log(this.state.col2wed);
   });

}


setCol2thu = () =>{
   this.setState(
     { col2thu: !this.state.col2thu },
     function(){
     console.log(this.state.col2thu);
   });

}



setCol2fri = () =>{
   this.setState(
     { col2fri: !this.state.col2fri },
     function(){
     console.log(this.state.col2fri);
   });

}




  setCol3mon = () =>{
     this.setState(
       { col2mon: !this.state.col2mon },
       function(){
       console.log(this.state.col2mon);
     });

}


  setCol3tue = () =>{
     this.setState(
       { col3tue: !this.state.col3tue },
       function(){
       console.log(this.state.col3tue);
     });

}
setCol3wed = () =>{
   this.setState(
     { col3wed: !this.state.col3wed },
     function(){
     console.log(this.state.col3wed);
   });

}


setCol3thu = () =>{
   this.setState(
     { col3thu: !this.state.col3thu },
     function(){
     console.log(this.state.col3thu);
   });

}



setCol3fri = () =>{
   this.setState(
     { col3fri: !this.state.col3fri },
     function(){
     console.log(this.state.col3fri);
   });

}


  setCol4mon = () =>{
     this.setState(
       { col4mon: !this.state.col4mon },
       function(){
       console.log(this.state.col4mon);
     });

}


  setCol4tue = () =>{
     this.setState(
       { col4tue: !this.state.col4tue },
       function(){
       console.log(this.state.col4tue);
     });

}
setCol4wed = () =>{
   this.setState(
     { col4wed: !this.state.col4wed },
     function(){
     console.log(this.state.col4wed);
   });

}


setCol4thu = () =>{
   this.setState(
     { col4thu: !this.state.col4thu },
     function(){
     console.log(this.state.col4thu);
   });

}



setCol4fri = () =>{
   this.setState(
     { col4fri: !this.state.col4fri },
     function(){
     console.log(this.state.col4fri);
   });

}

changeChildNo = (event) =>{

this.setState({childNo:event.target.value});

}

changeChildSchoolID = (event) =>{

this.setState({childSchoolID:event.target.value});

}

changeChildCategory = (event) =>{

this.setState({childCat:event.target.value});

}

changeChildName = (event) =>{

this.setState({childName:event.target.value});

}

changeChildSurname = (event) =>{

this.setState({childSurname:event.target.value});

}

changeAllergy = (event) =>{

this.setState({allergy:event.target.value});

}
changeChildAllergy = () =>{
var allergy = this.state.allergies;

allergy.push(this.state.allergy)

this.setState({allergies:allergy}, function(){

  console.log(this.state.allergies)
});

}

removeChildAllergy = (val) =>{

var allergy = this.state.allergies;


  allergy.splice(val);


this.setState({allergies:allergy}, function(){

  console.log(this.state.allergies)
});

}


changeChildClass = (event) =>{

this.setState({childClass:event.target.value});

}

changeChildGender = (event) =>{

this.setState({childGender:event.target.value});

}

changeCollector1No = (event) =>{

this.setState({collector1No:event.target.value}, function(){


});

}
changeCollector2No = (event) =>{

this.setState({collector2No:event.target.value});

}

changeCollector3No = (event) =>{

this.setState({collector3No:event.target.value});

}
changeCollector4No = (event) =>{

this.setState({collector4No:event.target.value});

}


changeCollector1Rel = (event) =>{

this.setState({collector1Rel:event.target.value}, function(){

  console.log('relationship' + this.state.collector1Rel)
});

}


changeCollector2Rel = (event) =>{

this.setState({collector2Rel:event.target.value});

}


changeCollector3Rel = (event) =>{

this.setState({collector3Rel:event.target.value});

}

changeCollector4Rel = (event) =>{

this.setState({collector4Rel:event.target.value});

}






addChild = () =>{

 if(this.state.childName === ''){

    alert(`please add child's name`);
  }

  else if(this.state.childSurame === ''){

      alert(`please add child's surname`);
    }

    else if(this.state.childClass === ''){

        alert(`please add child's class`);
      }
      else if(this.state.childGender === ''){

          alert(`please add child's gender`);
        }
        else if(this.state.collector1No === ''){

            alert(`please add at least 1 collector`);
          }
          else if(this.state.childSchoolID === ''){

              alert(`please add the child's ID `);
            }


                else{
                alert(`Adding child \n\r

                       Child name: ${this.state.childName} \n\r
                       Child surname: ${this.state.childSurname} \n\r
                       Child class: ${this.state.childClass} \n\r
                       Child gender: ${this.state.childGender} \n\r
                       Collector 1 No: ${this.state.collector1No} \n\r
                       Collector 2 No: ${this.state.collector2No} \n\r
                       Collector 3 No: ${this.state.collector3No} \n\r
                       Collector 4 No: ${this.state.collector4No} \n\r
                       `);

                       fetch('https://schoolportal.appsdesign.co.za/add_child', {
                           method: 'post',
                           headers: {'Content-Type' : 'application/json'},
                           body: JSON.stringify({

                        childno: this.state.childNo,
                        schoolID:this.state.childSchoolID,
                        childSchool:localStorage.getItem('schoolToken'),
                        schoolabv:localStorage.getItem('schoolAbv'),
                        pnum: localStorage.getItem('schoolphone'),
                        childname: this.state.childName,
                        childsurname: this.state.childSurname,
                        allergies:this.state.allergies,
                        childclass: this.state.childClass,
                        childgender: this.state.childGender,
                        category:this.state.childCat,
                        datecreated: new Date().toString(),
                        childcomments: "test comment",
                        collector1vcode: this.state.collector1No,
                        collector1rel:this.state.collector1Rel,
                        phone1:this.state.colNo1phone,
                        collector1allowed: [this.state.col1mon, this.state.col1tue, this.state.col1wed, this.state.col1thu, this.state.col1fri],
                        collector2vcode: this.state.collector2No,
                          collector2Rel:this.state.collector2Rel,
                          phone2:this.state.colNo2phone,
                        collector2allowed: [this.state.col2mon, this.state.col2tue, this.state.col2wed, this.state.col2thu, this.state.col2fri],
                        collector3code: this.state.collector3No,
                          collector3Rel:this.state.collector3Rel,
                          phone3:this.state.colNo3phone,
                        collector3allowed: [this.state.col3mon, this.state.col3tue, this.state.col3wed, this.state.col3thu, this.state.col3fri],
                        collector4code: this.state.collector4No,
                          collector4Rel:this.state.collector4Rel,
                          phone4:this.state.colNo4phone,
                        collector4allowed: [this.state.col4mon, this.state.col4tue, this.state.col4wed, this.state.col4thu, this.state.col4fri],
                        absent: false,
                        collected: false

                     })
                       })
                       .then(response =>{
                         this.setState({
                           data:[],
                           childNo:'',
                           childName:'',
                           childSurname:'',
                           allergies:[],
                           allergy:'',
                           childClass:'',
                           childGender:'',
                           collector1No:'',
                           collector1Rel:'',
                           col1mon:false,
                           col1tue:false,
                           col1wed:false,
                           col1thu:false,
                           col1fri:false,
                           collector2No:'',
                           collector2Rel:'',
                           col2mon:false,
                           col2tue:false,
                           col2wed:false,
                           col2thu:false,
                           col2fri:false,
                           collector3No:'',
                           collector3Rel:'',
                           col3mon:false,
                           col3tue:false,
                           col3wed:false,
                           col3thu:false,
                           col3fri:false,
                           collector4No:'',
                           collector4Rel:'',
                           col4mon:false,
                           col4tue:false,
                           col4wed:false,
                           col4thu:false,
                           col4fri:false,
                           searchShow:'searchHide',
                           colSearch:[],
                           searchName:'',
                           searchSurname:'',
                           colNo1:'',
                           colNo2:'Please enter a collector no ',
                           colNo3:'Please enter a collector no ',
                           colNo4:'Please enter a collector no ',
                           Colnumber:0,
                         },function(){

                           var elements = document.getElementsByTagName("input");
                           for (var ii=0; ii < elements.length; ii++) {
                             if (elements[ii].type === "text") {
                               elements[ii].value = "";
                             }
                           }

                            alert('Child has been added')


                          })


                      })




                }


}


searchCol = (val) =>{

this.setState({
  searchShow:'searchShow',
   Colnumber:val,

},function(){
  console.log(this.state.Colnumber);
})


}

setColNo = (val, cell) =>{

if(this.state.Colnumber === 1){
this.setState({
  searchShow:'searchHide',
  colNo1:val,
  collector1No:val,
  colNo1phone:cell,
}, function(){
  console.log('Collector added with: '+this.state.colNo1);
})
}
else if(this.state.Colnumber === 2){
this.setState({
  searchShow:'searchHide',
  colNo2:val,
  collector2No:val,
  colNo2phone:cell,
})
}

else if(this.state.Colnumber === 3){
this.setState({
  searchShow:'searchHide',
  colNo3:val,
  collector3No:val,
  colNo3phone:cell,
})
}

else if(this.state.Colnumber === 4){
this.setState({
  searchShow:'searchHide',
  colNo4:val,
  collector4No:val,
  colNo4phone:cell,
})
}


}



render(){

const schoolclasses = this.state.data.map((schoolclass, i) => {

return(

  <option key={i} value={schoolclass.assClass}>{schoolclass.assClass}</option>
)


});


const searchResults = this.state.colSearch.map((collector,i) =>{

var colfname = collector.name.toLowerCase() +' '+collector.surname.toLowerCase();

if(colfname.includes(this.state.searchSurname.toLowerCase())){

return (
  <div key={i}
  style={{borderBottom:'1px solid black', margin:'10px', color:'white'}}>

<button onClick={() => this.setColNo(collector.code, collector.cell)}>
  <p>Name: {collector.name}</p>
  <p>Surname: {collector.surname}</p>
  <p>ID No: {collector.code}</p>
</button>

  </div>
)
}
else{
  return null;
}



})



const als = this.state.allergies.map((val,i) =>{



  return <div style={{display: 'flex', justifyContent:'space-between', border:'1px solid black'}}><span style={{color:'black', fontWeight:'bold'}}>{val}</span> <button onClick={() => this.removeChildAllergy(i)}>&times;</button></div>
})

return(
  this.props.isAuthed ?

  <div className="ma2 pa2 br3 shadow-4" style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100, background:'white'}}>
  <h1>Enter child details</h1>


  <div className={this.state.searchShow} scroll="true">

<div style={{display:'flex', flexDirection:'row'}}>
  <input type="text" placeholder="Please Enter Surname" onKeyUp={this.onSearchSurname}/>
  <button onClick={this.doSearch}><FontAwesomeIcon icon={faSearch} /></button>
  </div>
<div style={{display:'flex',flexDirection:'row wrap', overflow:'scroll'}}>
  {searchResults}
</div>
</div>


    <div style={{display:'flex', flexDirection:'column',justifyContent:'space-evenly', border:'1px solid black' , padding:20, margin:10}}>

    <label htmlFor="childsid" style={{marginRight:21}}>
    Child ID
    <input
    type="text"
    placeholder="Child School ID"
    id="childsid"
    className="pa2 ma2"
    onKeyUp={this.changeChildSchoolID}
    /></label>
    <br/>




            <label htmlFor="childCategory">
            Child Category
          <select
          id="childCategory"
          className="pa2 ma2"
          onChange={this.changeChildCategory}
            >
          <option value="">Please select</option>
            <option value="W">Waiting class</option>
              <option value="A">After care</option>
                <option value="H">Half day</option>
                <option value="F">Full day</option>
                  <option value="S"> School</option>

                </select>
            </label><br/>


  <label htmlFor="childName" style={{marginRight:21}}>
  Child Name
  <input
  type="text"
  placeholder="Child Name"
  id="childName"
  className="pa2 ma2"
  onKeyUp={this.changeChildName}
  /></label>
  <br/>

  <label htmlFor="childSurname">
  Child Surname
  <input
  type="text"
  placeholder="Child Surname"
  id="childSurname"
  className="pa2 ma2"
  onKeyUp={this.changeChildSurname}
  />
  </label><br/>


  <div>
  <h3>Allergies:</h3>
    <label htmlFor="childAllergy">
    Add Allergy
    <input
    type="text"
    placeholder="Add Child Allergy"
    id="childAllergy"
    className="pa2 ma2"
    onKeyUp={this.changeAllergy}
    />
    </label>
  <button onClick={this.changeChildAllergy}> + </button><br/>
  <div style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', border:'1px solid black'}}>
  {als}
  </div>
  </div>




  <label htmlFor="childClass" style={{marginRight:20}}>
  Child Class
  <select
  id="childClass"
  className="pa2 ma2"
  onChange={this.changeChildClass}
  >
  <option value="">Please select</option>
  {schoolclasses}
        </select>
</label>
  <br/>



    <label htmlFor="childGender">
    Child Gender
  <select
  id="childGender"
  className="pa2 ma2"
  onChange={this.changeChildGender}
    >
  <option value="">Please select</option>
    <option value="male">Male</option>
      <option value="female">Female</option>
        <option value="other">Other</option>
        </select>
    </label><br/>




</div>
<div style={{border:'1px solid black' , padding:20, margin:10}}>

      <label htmlFor="collector1No">
      Collector 1 No<br/>
      <button onClick={() => this.searchCol(1)} style={{border:'1px solid black', backgroundColor:'white'}}>
      search<FontAwesomeIcon icon={faSearch} />
      </button>
    <input
    type="text"
    value={this.state.colNo1}
    placeholder="Enter Collector No"
    id="collector1No"
    className="pa2 ma2"
    onChange={this.changeCollector1No}
    />
      </label><br/>



        <label htmlFor="collector1Rel">
         Relationship
        <select
        id="collector1Rel"
        className="pa2 ma2"
        onChange={this.changeCollector1Rel}
        >
        <option value="">Please select</option>
        <option value="Mother">Mother</option>

        <option value="Father">Father</option>

        <option value="Legal Guardian">Legal Guardian</option>

        <option value="Family Member">Family Member</option>

        <option value="Friend">Friend</option>

        <option value="Shuttle Driver">Shuttle Driver</option>

            </select>
        </label><br/>






<h4>Allowed days</h4>
<label htmlFor="col1mon" style={{margin:5}}>
Monday
<input type="checkbox" id="col1mon" onClick={this.setCol1mon}/>
</label>


<label htmlFor="col1tue" style={{margin:5}}>
Tuesday
<input type="checkbox" id="col1tue" onClick={this.setCol1tue}/>
</label> &nbsp;


<label htmlFor="col1wed" style={{margin:5}}>
Wednesday
<input type="checkbox" id="col1wed" onClick={this.setCol1wed}/>
</label> &nbsp;



<label htmlFor="col1thu" style={{margin:5}}>
Thursday
<input type="checkbox" id="col1thu" onClick={this.setCol1thu}/>
</label> &nbsp;


<label htmlFor="col1fri" style={{margin:5}}>
Friday
<input type="checkbox" id="col1fri" onClick={this.setCol1fri}/>
</label>


</div>






<div style={{border:'1px solid black' , padding:20, margin:10}}>
      <label htmlFor="collector2No">
      Collector 2 No<br/>
      <button onClick={() => this.searchCol(2)} style={{border:'1px solid black', backgroundColor:'white'}}>
      search<FontAwesomeIcon icon={faSearch} />
      </button>
    <input
    type="text"
      value={this.state.colNo2}
    placeholder="Enter Collector No"
    id="collector2No"
    className="pa2 ma2"
    onChange={this.changeCollector2No}
    />
      </label><br/>




              <label htmlFor="collector2Rel">
               Relationship
              <select
              id="collector2Rel"
              className="pa2 ma2"
              onChange={this.changeCollector2Rel}
              >
              <option value="">Please select</option>
              <option value="Mother">Mother</option>

              <option value="Father">Father</option>

              <option value="Legal Guardian">Legal Guardian</option>

              <option value="Family Member">Family Member</option>

              <option value="Friend">Friend</option>

              <option value="Shuttle Driver">Shuttle Driver</option>

                  </select>
              </label><br/>






<h4>Allowed days</h4>
<label htmlFor="col2mon" style={{margin:5}}>
Monday
<input type="checkbox" id="col2mon" onClick={this.setCol2mon}/>
</label>


<label htmlFor="col2tue" style={{margin:5}}>
Tuesday
<input type="checkbox" id="col2tue" onClick={this.setCol2tue}/>
</label> &nbsp;


<label htmlFor="col2wed" style={{margin:5}}>
Wednesday
<input type="checkbox" id="col2wed" onClick={this.setCol2wed}/>
</label> &nbsp;



<label htmlFor="col2thu" style={{margin:5}}>
Thursday
<input type="checkbox" id="col2thu" onClick={this.setCol2thu}/>
</label> &nbsp;


<label htmlFor="col2fri" style={{margin:5}}>
Friday
<input type="checkbox" id="col2fri" onClick={this.setCol2fri}/>
</label>


</div>





<div style={{border:'1px solid black' , padding:20, margin:10}}>
      <label htmlFor="collector3No">
      Collector 3 No<br/>
      <button onClick={() => this.searchCol(3)} style={{border:'1px solid black', backgroundColor:'white'}}>
      search<FontAwesomeIcon icon={faSearch} />
      </button>
    <input
    type="text"
      value={this.state.colNo3}
    placeholder="Enter Collector No"
    id="collector3No"
    className="pa2 ma2"
    onChange={this.changeCollector3No}
    />
      </label><br/>






                            <label htmlFor="collector3Rel">
                             Relationship
                            <select
                            id="collector3Rel"
                            className="pa2 ma2"
                            onChange={this.changeCollector3Rel}
                            >
                            <option value="">Please select</option>
                            <option value="Mother">Mother</option>

                            <option value="Father">Father</option>

                            <option value="Legal Guardian">Legal Guardian</option>

                            <option value="Family Member">Family Member</option>

                            <option value="Friend">Friend</option>

                            <option value="Shuttle Driver">Shuttle Driver</option>

                                </select>
                            </label><br/>





<h4>Allowed days</h4>
<label htmlFor="col3mon" style={{margin:5}}>
Monday
<input type="checkbox" id="col3mon" onClick={this.setCol3mon}/>
</label>


<label htmlFor="col3tue" style={{margin:5}}>
Tuesday
<input type="checkbox" id="col3tue" onClick={this.setCol3tue}/>
</label> &nbsp;


<label htmlFor="col3wed" style={{margin:5}}>
Wednesday
<input type="checkbox" id="col3wed" onClick={this.setCol3wed}/>
</label> &nbsp;



<label htmlFor="col3thu" style={{margin:5}}>
Thursday
<input type="checkbox" id="col3thu" onClick={this.setCol3thu}/>
</label> &nbsp;


<label htmlFor="col3fri" style={{margin:5}}>
Friday
<input type="checkbox" id="col3fri" onClick={this.setCol13fri}/>
</label>


</div>





<div style={{border:'1px solid black' , padding:20, margin:10}}>
      <label htmlFor="collector1No">
      Collector 4 No<br/>
      <button onClick={() => this.searchCol(4)} style={{border:'1px solid black', backgroundColor:'white'}}>
      search<FontAwesomeIcon icon={faSearch} />
      </button>
    <input
    type="text"
      value={this.state.colNo4}
    placeholder="Enter Collector No"
    id="collector4No"
    className="pa2 ma2"
    onChange={this.changeCollector4No}
    />
      </label><br/>




                    <label htmlFor="collector4Rel">
                     Relationship
                    <select
                    id="collector4Rel"
                    className="pa2 ma2"
                    onChange={this.changeCollector4Rel}
                    >
                    <option value="">Please select</option>
                    <option value="Mother">Mother</option>

                    <option value="Father">Father</option>

                    <option value="Legal Guardian">Legal Guardian</option>

                    <option value="Family Member">Family Member</option>

                    <option value="Friend">Friend</option>

                    <option value="Shuttle Driver">Shuttle Driver</option>

                        </select>
                    </label><br/>





<h4>Allowed days</h4>
<label htmlFor="col4mon" style={{margin:5}}>
Monday
<input type="checkbox" id="col4mon" onClick={this.setCol4mon}/>
</label>


<label htmlFor="col4tue" style={{margin:5}}>
Tuesday
<input type="checkbox" id="col4tue" onClick={this.setCol4tue}/>
</label> &nbsp;


<label htmlFor="col4wed" style={{margin:5}}>
Wednesday
<input type="checkbox" id="col4wed" onClick={this.setCol4wed}/>
</label> &nbsp;



<label htmlFor="col4thu" style={{margin:5}}>
Thursday
<input type="checkbox" id="col4thu" onClick={this.setCol4thu}/>
</label> &nbsp;


<label htmlFor="col4fri" style={{margin:5}}>
Friday
<input type="checkbox" id="col4fri" onClick={this.setCol4fri}/>
</label>


</div>




    <button className="br3 ma3 pa3 bg-blue br-blue" style={{width:200, alignSelf:'center'}} onClick={this.addChild}>Add Child</button>

  </div>
  :

  <h1> your out, sorry not authenticated </h1>

)

}

}

export default AddChild;



// WEBPACK FOOTER //
// ./src/components/AddChild/AddChild.js